import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { GeneralSnackService } from '../../shared/services/general-snack.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const generalSnackService = inject(GeneralSnackService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('🔥 ErrorInterceptor:', error);

      // 🌐 Error de red / CORS / backend caído
      if (error.status === 0) {
        generalSnackService.viewSnacAlert(
          'No se pudo conectar con el servidor',
          'error',
          'Error de red',
        );
        return throwError(() => error);
      }

      if (error.status === 401) {
        generalSnackService.viewSnacAlert(
          error.error?.message || 'No autorizado para realizar esta operación',
          'alert',
          'Acceso denegado',
        );
      }

      if (error.status === 403) {
        generalSnackService.viewSnacAlert(error.error.message, 'alert', 'Acceso denegado');
      }

      if (error.status === 419) {
        generalSnackService.viewSnacAlert(
          error.error?.message || 'La operación expiró, intenta nuevamente',
          'error',
          'Solicitud expirada',
        );
      }

      if (error.status === 500) {
        generalSnackService.viewSnacAlert(
          'Error interno',
          'error',
          'Ha ocurrido un error en el servicio',
        );
      }

      return throwError(() => error);
    }),
  );
};
